import Svg, { Rect, Defs, Pattern as SvgPattern, Path } from "react-native-svg";
import { useAlarmStateBackgroundColor, useStripeColor, type StripeState } from "../utils/stripe-pattern";

interface DiagonalStripeSquareProps {
  state: StripeState;
  size: number;
  borderRadius?: number;
}

/**
 * Renders a square with a diagonal stripe pattern matching the weekly schedule columns.
 */
export function DiagonalStripeSquare({ state, size, borderRadius = 4 }: DiagonalStripeSquareProps) {
  const getAlarmStateBackgroundColor = useAlarmStateBackgroundColor();
  const getStripeColor = useStripeColor();

  return (
    <Svg width={size} height={size}>
      {/* @ts-expect-error react-native-svg Defs children typing incomplete with React 19 types */}
      <Defs>
        <SvgPattern id={`diag-stripe-${state}-${size}`} patternUnits="userSpaceOnUse" width="6" height="6">
          <Rect width="6" height="6" fill={getAlarmStateBackgroundColor(state)} />
          <Path
            d="M-6,6 l6,-6 M0,6 l6,-6 M6,6 l6,-6"
            stroke={getStripeColor(state)}
            strokeWidth="1"
            strokeLinecap="square"
          />
        </SvgPattern>
      </Defs>
      <Rect width={size} height={size} rx={borderRadius} fill={`url(#diag-stripe-${state}-${size})`} />
    </Svg>
  );
}
